import {React} from 'common'
import {styled} from '@mui/material/styles'
import Box from '@mui/material/Box'
import {useState} from 'react'
import Toolbar from './Toolbar/Toolbar'
import MobileMenu from './MobileMenu'
import MenuProfile from './MenuProfile'
import MuiAppBar from '@mui/material/AppBar'
import {HEADER_HEIGHT, SIDE_MENU_WIDTH} from 'appearance/styles'
import MenuLanguage from './MenuLanguage'

const Header = ({openMenu, onClickOpenMenu}) => {
    const [anchorElProfile, setAnchorElProfile] = useState(null)
    const [anchorElLanguage, setAnchorElLanguage] = useState(null)

    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null)

    const isProfileMenuOpen = Boolean(anchorElProfile)
    const isLanguageMenuOpen = Boolean(anchorElLanguage)
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

    const handleProfileMenuOpen = (event) => {
        setAnchorElProfile(event.currentTarget)
    }
    const handleLanguageMenuOpen = (event) => {
        setAnchorElLanguage(event.currentTarget)
    }
    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null)
    }
    const handleProfileMenuClose = () => {
        setAnchorElProfile(null)
        handleMobileMenuClose()
    }
    const handleLanguageMenuClose = () => {
        setAnchorElLanguage(null)
        handleMobileMenuClose()
    }
    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget)
    }

    return (
        <Box sx={{flexGrow: 1}}>
            <AppBar position="fixed" open={openMenu}>
                <Toolbar
                    handleProfileMenuOpen={handleProfileMenuOpen}
                    handleLanguageMenuOpen={handleLanguageMenuOpen}
                    handleMobileMenuOpen={handleMobileMenuOpen}
                    onClickOpenMenu={onClickOpenMenu}
                    openMenu={openMenu}
                />
            </AppBar>
            <MobileMenu
                mobileMoreAnchorEl={mobileMoreAnchorEl}
                isMobileMenuOpen={isMobileMenuOpen}
                handleMobileMenuClose={handleMobileMenuClose}
                handleProfileMenuOpen={handleProfileMenuOpen}
                handleLanguageMenuOpen={handleLanguageMenuOpen}
            />
            <MenuProfile
                anchorEl={anchorElProfile}
                isMenuOpen={isProfileMenuOpen}
                handleMenuClose={handleProfileMenuClose}
            />
            <MenuLanguage
                anchorEl={anchorElLanguage}
                isMenuOpen={isLanguageMenuOpen}
                handleMenuClose={handleLanguageMenuClose}
            />
        </Box>
    )
}

export default Header

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({theme, open}) => ({
    zIndex: theme.zIndex.drawer + 1,
    height: HEADER_HEIGHT,
    background: (theme.vars || theme).palette.background.paper,
    color: (theme.vars || theme).palette.text.primary,
    boxShadow: 'none',
    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginInlineStart: SIDE_MENU_WIDTH,
        width: `calc(100% - ${SIDE_MENU_WIDTH}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}))
